import React, { useMemo } from "react";

// Gentle golden light sparkles that drift upward (inspired by the Essentiel site).
export default function Sparkles({ count = 22 }) {
  const items = useMemo(
    () =>
      Array.from({ length: count }, () => {
        const size = 1.5 + Math.random() * 3.5;
        return {
          left: Math.random() * 100,
          size,
          duration: 11 + Math.random() * 16,
          delay: -Math.random() * 22,
          opacity: 0.35 + Math.random() * 0.5,
        };
      }),
    [count]
  );

  return (
    <div className="sparkles" aria-hidden="true">
      {items.map((s, i) => (
        <span
          key={i}
          className="sparkle"
          style={{
            left: `${s.left}%`,
            width: `${s.size}px`,
            height: `${s.size}px`,
            animationDuration: `${s.duration}s`,
            animationDelay: `${s.delay}s`,
            opacity: s.opacity,
          }}
        />
      ))}
    </div>
  );
}
